exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*\nTo change this license header, choose License Headers in Project Properties.\nTo change this template file, choose Tools | Templates\nand open the template in the editor.\n*/\n/*\n    Created on : Jul 18, 2016, 11:44:53 AM\n    Author     : shane.rhoden\n*/\n\n/* new CSS from Shane Rhoden */\n\n#modalTitle{color:#006068 !important; margin-left: 1rem; text-align: left !important;}\n\n.modalHeader{ margin-left: 1rem; color:#006068;}\n\n.locationItem{\n    margin-left: 0rem;\n    padding: 10px;\n    font-size: 1.125rem;\n}\n\n.locationList a{\n    border-bottom:solid thin grey;\n}\n\n.locationList a:hover{\n    background-color: #222222;\n    color:#fff;\n}\n\n.locationList a:last-of-type{\n    border-bottom:none;\n}\n\n.locationItem a:hover{\n    color:#fff;\n}\n\n.locationList a{display: block;}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./resource/css/modalStyle.css
// module id = 660
// module chunks = 0